import { STagDto } from "@/__generated__/graphql";
import { normalizeHashtag } from "@/lib/normalizeHashtag";
import { snakeCase } from "@/lib/snakeCase";
import { Box } from "@mui/material";
import Link from "next/link";

type Props = {
  tags?: Array<STagDto | null> | null;
};

export default function ProductDescriptionTags({ tags }: Props) {
  const items = (tags ?? [])
    .map((tag) => {
      const canonical = tag?.title ? normalizeHashtag(tag.title) : null;
      if (!tag || !canonical) return null;
      return { id: tag.id, canonical };
    })
    .filter((tag): tag is { id: number; canonical: string } => Boolean(tag));

  if (!items.length) return null;

  return (
    <Box
      component="ul"
      aria-label="برچسب‌های محصول"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        p: 0,
        m: 0,
        mt: 2.5,
        listStyle: "none",
      }}
    >
      {items.map((tag) => (
        <Box component="li" key={tag.id}>
          <Box
            component={Link}
            href={`/products?tag=${encodeURIComponent(tag.canonical)}`}
            title={tag.canonical}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 1.25,
              py: 0.45,
              borderRadius: 10,
              bgcolor: "grey.A100",
              color: "grey.700",
              fontSize: "0.8rem",
              lineHeight: 1.6,
              textDecoration: "none",
              transition: "background-color 0.2s ease, color 0.2s ease",
              "&:hover": {
                bgcolor: "secondary.50",
                color: "grey.900",
              },
            }}
          >
            #{snakeCase(tag.canonical)}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
